import React from 'react';
import config from 'cfg';
import { Link } from 'react-router';
import * as rmd from 'material-ui';
import styled from 'styled-components';
import auth from '../auth';
import _ from 'lodash';
import Promise from 'bluebird';
import fetch from '../../../common/fetch';
import _fetch from 'isomorphic-fetch';
import ContentSave from 'material-ui/svg-icons/content/save';
import ContentDelete from 'material-ui/svg-icons/action/delete-forever';
import ContentEdit from 'material-ui/svg-icons/editor/mode-edit';
import ContentSaving from 'material-ui/svg-icons/action/update';
import ContentUpdate from 'material-ui/svg-icons/file/file-upload';
import moment from 'moment';

const Td = styled.td`
    padding: 4px;
`;

const Event = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    text-align: left;
    margin-bottom: 3px;
    > div {
        padding: 0 10px;
        flex-grow: 1;
    }
    .date {
        width: 80px;
    }
    .sport {
        width: 250px;
    }
    .name {
        width: 300px;
    }
    .channels {
        width: 250px;
    }
    .description {
        width: 500px;
    }
    .actions {
        width: 120px;
        display: flex;
        justify-content: space-around;
    }
    ${props => {
        if (props.header) {
            return `
      > div {
        padding: 10px 10px;

      }
        font-weight: 700;
        color: rgba(0,0,0,.7);
      `;
        }
    }};
`;

class TvProgramDashboard extends React.Component {
    constructor(props) {
        let queryDate = _.get(props, 'location.query.date', null);
        super(props);
        this.state = {
            arraysCount: {},
            program: [],
            startDate: queryDate ? moment(queryDate, 'YYYY-MM-DD').toDate() : moment().toDate(),
            key: _.get(props, 'location.query.key', 'drdk_wo_2018'),
            open: false
        };
    }
    componentDidMount = () => {
        this.loadData()
            .then(data => {
                this.setState({
                    ...data,
                    dataLoaded: true
                });
            })
            .catch(e => this.setState({ dataLoaded: true, error: true }));
    };
    loadData = () => {
        if (!this.state.key) return Promise.resolve();
        return Promise.props({
            program: fetch.get(`${config.widgets.url}/tv-program?key=${this.state.key}`)
        })
            .then(data => data)
            .catch(err => console.error(err));
    };
    programStructure = () => {
        return [
            {
                key: 'sport',
                type: 'select',
                multiple: false,
                values: _.uniqBy(this.state.program, event => event.sport).map(event => ({
                    value: event.sport,
                    label: event.sport
                }))
            },
            { key: 'sport', type: 'string' },
            // { key: "sportId", type: "number" },
            { key: 'eventName', type: 'string' },
            { key: 'description', type: 'string' },
            { key: 'icon', type: 'string' },
            { key: 'startDate', type: 'date' },
            { key: 'linkUrl', type: 'string' },
            { key: 'linkTitle', type: 'string' },
            {
                key: 'highlightedCountryId',
                type: 'select',
                values: [{ value: null, label: '' }, { value: 1, label: 'Denmark' }]
            },

            {
                key: 'channels',
                type: 'select',
                multiple: true,
                values: [
                    { value: 'drtv', label: 'drtv' },
                    { value: 'drdk', label: 'drdk' },
                    { value: 'dr1', label: 'dr1' },
                    { value: 'dr2', label: 'dr2' },
                    { value: 'dr3', label: 'dr3' },
                    { value: 'eurosport_player', label: 'eurosport_player ' },
                    { value: 'eurosport1', label: 'eurosport1' },
                    { value: 'eurosport2', label: 'eurosport2' },
                    { value: 'kanal5', label: 'kanal5' }
                ]
            }
            // {
            //   key: "links",
            //   type: "array",
            //   structure: [
            //     { key: "url", type: "string" },
            //     { key: "title", type: "string" }
            //   ]
            // }
        ];
    };

    handleTextFieldChange = (key, type, event) => {
        let { value } = event.target;
        if (type === 'number') value = +value;
        this.setState({
            [key]: value
        });
    };

    handleArrayAdd = (key, refName, structure, i) => {
        let currentValues = this.state[key] || [];

        if (structure) {
            let newValue = {};
            if (currentValues[i]) newValue = currentValues[i];
            structure.forEach(({ type, key: innerKey }, y) => {
                let ref = this.refs[`${key}_${i}_${innerKey}_${y}`];
                newValue[innerKey] = ref.input.value;
                // ref.input.value = null;
            });

            this.setState({
                [key]: currentValues[i] ? currentValues : [...currentValues, newValue],
                arraysCount: currentValues[i]
                    ? this.state.arraysCount
                    : {
                          ...this.state.arraysCount,
                          [key]: this.state.arraysCount[key] + 1 || 2
                      }
            });
        } else {
            let newValue = this.refs[refName].input.value;

            this.setState({
                [key]: currentValues[i]
                    ? [...currentValues.slice(0, i), newValue, ...currentValues.slice(i + 1)]
                    : [...currentValues, newValue],
                arraysCount: currentValues[i]
                    ? this.state.arraysCount
                    : {
                          ...this.state.arraysCount,
                          [key]: this.state.arraysCount[key] + 1 || 2
                      }
            });
        }
    };

    handleArrayDelete = (key, value) => {
        let currentValues = this.state[key];
        this.setState({
            [key]: currentValues.filter(v => v !== value)
        });
    };

    handleSelectChange = (key, value) => this.setState({ [key]: value });

    renderSelect = (key, values, multiple) => {
        return (
            <rmd.SelectField
                multiple={multiple}
                floatingLabelText={key}
                value={this.state[key]}
                fullWidth
                onChange={(event, index, value) => this.handleSelectChange(key, value)}
            >
                {values.map(({ value: v, label }) => {
                    return (
                        <rmd.MenuItem
                            primaryText={label}
                            value={v}
                            key={v}
                            insetChildren={multiple}
                            checked={multiple && this.state[key] && this.state[key].indexOf(v) > -1}
                        />
                    );
                })}
            </rmd.SelectField>
        );
    };

    getEventData = () => {
        return _.omit(this.state, [
            'arraysCount',
            'program',
            'dataLoaded',
            'error',
            'saving',
            'editId',
            '_id',
            'createdAt',
            'updatedAt',
            '__v'
        ]);
    };

    resettedState = () => {
        return this.programStructure().reduce(
            (prev, cur) => {
                if (cur.key === 'startDate') return prev;
                prev[cur.key] = undefined;
                return prev;
            },
            { arraysCount: {}, editId: null }
        );
    };

    handleEventAdd = () => {
        const user = auth.getUser();

        this.setState({ saving: true }, () => {
            fetch
                .post(
                    `${config.widgets.url}/tv-program`,
                    {},
                    {
                        program: {
                            ...this.getEventData(),
                            key: this.state.key
                        },
                        customer: {
                            client: user.client,
                            user: user.username
                        }
                    }
                )
                .then(() => {
                    this.setState({ saving: false });
                    this.loadData().then(data => this.setState({ ...data, ...this.resettedState() }));
                });
        });
    };

    handleEventDelete = id => {
        _fetch(`${config.widgets.url}/tv-program/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(this.loadData)
            .then(data => this.setState({ ...data, ...this.resettedState() }));
    };

    handleEventUpdate = id => {
        _fetch(`${config.widgets.url}/tv-program/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ program: this.getEventData() })
        })
            .then(this.loadData)
            .then(data => this.setState({ ...data, editId: null, ...this.resettedState(), open: false }));
    };

    renderArrays = (key, structure) => {
        let elements = [];
        for (let i = 0; i < (this.state.arraysCount[key] || 1); i++) {
            elements.push(
                <div key={i}>
                    {structure && (
                        <div style={{ padding: 10, border: '3px solid rgba(0,0,0,.1)', marginBottom: 10 }}>
                            {structure.map(({ type: innerType, key: innerKey }, y) => {
                                let ref = `${key}_${i}_${innerKey}_${y}`;
                                // if (this.state[key]) {console.log('this.', this.state[key][i][innerKey])}
                                return (
                                    <rmd.TextField
                                        type={'string'}
                                        ref={ref}
                                        id={ref}
                                        fullWidth
                                        key={y}
                                        floatingLabelText={`${key}: ${innerKey}`}
                                    />
                                );
                            })}
                            {i === (this.state.arraysCount[key] - 1 || 0) && (
                                <rmd.RaisedButton
                                    label="Add this link"
                                    onTouchTap={() => this.handleArrayAdd(key, `input_${key}_${i}`, structure, i)}
                                />
                            )}
                        </div>
                    )}
                    {!structure && (
                        <rmd.TextField
                            type={'string'}
                            fullWidth
                            style={{ marginRight: 10 }}
                            ref={`input_${key}_${i}`}
                            onChange={() => {
                                this.handleArrayAdd(key, `input_${key}_${i}`, null, i);
                            }}
                            floatingLabelText={`${key}: ${i + 1}`}
                        />
                    )}
                </div>
            );
        }
        return <div style={{ display: !structure ? 'flex' : 'block' }}>{elements}</div>;
    };

    renderSaveButton = () => {
        let label = 'Save';
        if (this.state.saving) label = 'Saving...';

        return (
            <rmd.FloatingActionButton
                style={{ marginTop: 20, position: 'absolute', right: 20, bottom: 120 }}
                disabled={this.state.saving}
                onTouchTap={() => {
                    return this.state.editId ? this.handleEventUpdate(this.state.editId) : this.handleEventAdd();
                }}
            >
                {!this.state.saving && !this.state.editId && <ContentSave />}
                {!this.state.saving && this.state.editId && <ContentUpdate />}
                {this.state.saving && <ContentSaving />}
            </rmd.FloatingActionButton>
        );
    };

    handleDateChange = (key, date) => {
        this.props.router.push({
            pathname: '/tv-program',
            query: {
                ...this.props.location.query,
                date: moment(date).format('YYYY-MM-DD')
            }
        });
        this.setState({
            [key]: date
        });
    };

    handleChangeTimePicker24 = (key, date) => {
        this.setState({ [key]: date });
    };

    renderDatePicker = key => {
        let timezone = moment().utcOffset() / 60;
        let sign = Math.sign(timezone) >= 0 ? '+' : '-';
        return (
            <div>
                {/* <rmd.DatePicker
          hintText={key}
          floatingLabelText={`Start date (Timezone: ${sign}${timezone} hours)`}
          value={this.state[key]}
          onChange={(event, date) => this.handleDateChange(key, date)}
        /> */}
                <rmd.TimePicker
                    format="24hr"
                    fullWidth
                    floatingLabelText={`Start time (Timezone: ${sign}${timezone} hours)`}
                    value={this.state[key]}
                    onChange={(event, date) => this.handleChangeTimePicker24(key, date)}
                />
            </div>
        );
    };

    /*render() {
    return (
      <div>
        <div style={{ display: "flex" }}>
          <h1>TV Program Dashboard</h1>
          <rmd.TextField
            style={{ width: 400, marginLeft: 30 }}
            value={this.state.key || ""}
            type="text"
            floatingLabelText="Key for events group (drdk_wo_2018)"
            onChange={event => this.handleTextFieldChange("key", "text", event)}
          />
        </div>
        <div className="row">
          <div className="col-xs-6">
            {this.programStructure().map(
              ({ key, type, values, multiple, structure }, i) => {
                switch (type) {
                  case "string":
                  case "number":
                    return (
                      <div key={key}>
                        <rmd.TextField
                          value={this.state[key] || ""}
                          type={type}
                          floatingLabelText={key}
                          onChange={event =>
                            this.handleTextFieldChange(key, type, event)
                          }
                        />
                      </div>
                    );

                  case "array":
                    return (
                      <div key={i}>{this.renderArrays(key, structure)}</div>
                    );
                  case "select":
                    return (
                      <div key={i}>
                        {this.renderSelect(key, values, multiple)}
                      </div>
                    );
                  case "date":
                    return <div key={i}>{this.renderDatePicker(key)}</div>;
                }
              }
            )}
          </div>
          <div className="col-xs-6">
            <div style={{ height: 500, overflowY: "scroll" }}>
              <table style={{ width: "100%", whiteSpace: "nowrap" }}>
                <tbody>
                  {_.sortBy(this.state.program, "updatedAt").map(event => {
                    let { _id, eventName, sport, startDate } = event;
                    return (
                      <tr
                        onClick={() => this.setState({ ...event, editId: _id })}
                        key={_id}
                      >
                        <Td>{moment(startDate).format("MM/DD, HH:mm")}</Td>
                        <Td>{sport}</Td>
                        <Td
                          style={{
                            maxWidth: 200,
                            width: 200,
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}
                        >
                          {eventName}
                        </Td>
                        <Td>
                          <rmd.IconButton
                            onTouchTap={() => this.handleEventDelete(_id)}
                            style={{ marginRight: 30 }}
                          >
                            <ContentDelete />
                          </rmd.IconButton>
                        </Td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {this.renderSaveButton()}
        <div style={{ height: 100 }} />
      </div>
    );
  }*/

    renderEventsForDate = () => {
        let { startDate } = this.state;

        if (!startDate) return null;

        return (
            <div style={{ marginBottom: 50 }}>
                <Event header>
                    <div className="date">Time</div>
                    <div className="sport">Sport</div>
                    <div className="name">Event name</div>
                    <div className="description">Description</div>
                    <div className="channels">Channels</div>
                    <div className="actions">Actions</div>
                </Event>
                {_.sortBy(this.state.program, ['startDate'])
                    .filter(p => p.startDate)
                    .filter(p => moment(p.startDate).format('YYYY-MM-DD') === moment(startDate).format('YYYY-MM-DD'))
                    .map(event => {
                        let { _id, eventName, sport, startDate, description, channels } = event;
                        return (
                            <Event key={_id}>
                                <div className="date">{moment(startDate).format('HH:mm')}</div>
                                <div className="sport">{sport}</div>
                                <div className="name">{eventName}</div>
                                <div className="description">{description}</div>
                                <div className="channels">
                                    {channels.reduce((prev, cur) => {
                                        prev += `${cur}, `;
                                        return prev;
                                    }, ``)}
                                </div>
                                <div className="actions">
                                    <rmd.IconButton
                                        tooltip="Edit"
                                        onTouchTap={() =>
                                            this.setState({
                                                ...event,
                                                startDate: moment(startDate).toDate(),
                                                editId: _id,
                                                open: true
                                            })
                                        }
                                    >
                                        <ContentEdit />
                                    </rmd.IconButton>
                                    <rmd.IconButton
                                        tooltip="Delete forever"
                                        onTouchTap={() => this.handleEventDelete(_id)}
                                    >
                                        <ContentDelete />
                                    </rmd.IconButton>
                                </div>
                            </Event>
                        );
                    })}
            </div>
        );
    };

    handleOpen = () => {
        this.setState({ open: true, ...this.resettedState() });
    };

    handleClose = () => {
        this.setState({ open: false, ...this.resettedState() });
    };

    render() {
        let programStructure = this.programStructure();

        if (!this.state.startDate) return null;

        const actions = [
            <rmd.FlatButton label="Cancel" primary onClick={this.handleClose} />,
            <rmd.FlatButton
                label="Submit"
                primary
                disabled={this.state.saving}
                onClick={() => {
                    return this.state.editId ? this.handleEventUpdate(this.state.editId) : this.handleEventAdd();
                }}
            />
        ];

        return (
            <div>
                <div>
                    {!this.state.startDate && <h3>Choose date you want to see/add events for</h3>}
                    {this.state.startDate && (
                        <h3>Date selected: {moment(this.state.startDate).format('dddd, MMMM DD (YYYY)')}</h3>
                    )}
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <rmd.DatePicker
                            floatingLabelText={`Choose date`}
                            value={this.state.startDate}
                            onChange={(event, date) => this.handleDateChange('startDate', date)}
                        />
                        <rmd.TextField
                            value={this.state.key || ''}
                            type="text"
                            floatingLabelText="Key for events group"
                            onChange={event => this.setState({ key: event.target.value })}
                            onBlur={() => {
                                this.props.router.push({
                                    pathname: '/tv-program',
                                    query: { ...this.props.location.query, key: this.state.key }
                                });
                                this.loadData().then(data => this.setState(data));
                            }}
                        />
                        <rmd.RaisedButton label="Add new event for this day" onClick={this.handleOpen} />
                    </div>
                </div>
                <div>{this.renderEventsForDate()}</div>
                <div>
                    <rmd.Dialog
                        title="Event"
                        actions={actions}
                        modal={false}
                        open={this.state.open}
                        onRequestClose={this.handleClose}
                        autoScrollBodyContent
                    >
                        <div className="row">
                            <div className="col-xs-6">
                                {programStructure
                                    .filter(p => p.type === 'string' || p.type === 'number')
                                    .map(({ key, type, values, multiple, structure }, i) => {
                                        return (
                                            <div key={key}>
                                                <rmd.TextField
                                                    value={this.state[key] || ''}
                                                    type={type}
                                                    fullWidth
                                                    floatingLabelText={key}
                                                    onChange={event => this.handleTextFieldChange(key, type, event)}
                                                />
                                            </div>
                                        );
                                    })}
                            </div>
                            <div className="col-xs-6">
                                {programStructure
                                    .filter(p => p.type === 'array' || p.type === 'select' || p.type === 'date')
                                    .map(({ key, type, values, multiple, structure }, i) => {
                                        switch (type) {
                                            case 'array':
                                                return <div key={i}>{this.renderArrays(key, structure)}</div>;
                                            case 'select':
                                                return <div key={i}>{this.renderSelect(key, values, multiple)}</div>;
                                            case 'date':
                                                return <div key={i}>{this.renderDatePicker(key)}</div>;
                                        }
                                    })}
                            </div>
                        </div>
                    </rmd.Dialog>
                </div>
            </div>
        );
    }
}

export default TvProgramDashboard;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/TvProgramDashboard.js
 **/